import { z } from "zod";
import { isoDate, phone, email, id } from "./common.js";

/** Public landing-page lead capture (§5). `website` is a honeypot — must be empty. */
export const LeadFormInput = z.object({
  name: z.string().min(1).max(120),
  phone,
  email: email.optional(),
  desiredVehicleId: id.optional(),
  desiredStartDate: isoDate.optional(),
  desiredDurationMonths: z.number().int().min(1).max(60).optional(),
  notes: z.string().max(2000).optional(),
  website: z.string().max(0).optional(),     // honeypot: bots fill it; humans never see it
});
export type LeadFormInput = z.infer<typeof LeadFormInput>;

/** Presigned-upload request (§7.3). */
export const PresignUploadInput = z.object({
  clientId: id,
  fileName: z.string().min(1),
  mimeType: z.string().min(1),
  sizeBytes: z.number().int().min(1),
});
export type PresignUploadInput = z.infer<typeof PresignUploadInput>;
